import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateHabilidadeColumnsDefinition
 */

type Props = {
  onExportar: (idAvaliacaoHabilidade: number) => void,
  onEditar: (idAvaliacaoHabilidade: number) => void,
  onDeletar: (idAvaliacaoHabilidade: number) => void,
};

export const GenerateHabilidadeColumnsDefinition = ({
  onExportar,
  onEditar,
  onDeletar,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1: return "C";
      case 2: return "A";
      case 3: return "D";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1: return "green";
      case 2: return "red";
      case 3: return "yellow";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1: return "Avaliação concluída";
      case 2: return "Avalição atrasada";
      case 3: return "Avalição dentro do prazo";
      default:
        return "?";
    }
  };

  const computeTotalPontosClass = (totalPontos: number): string => {
    if (totalPontos < 41) {
      return 'bg-[#ef4836] text-white py-[.1rem] px-[.4rem] font-normal';
    }
    else if (totalPontos < 66) {
      return 'bg-[#d4aa00] text-white py-[.1rem] px-[.4rem] font-normal';
    }
    return 'bg-[#44b6ae] text-white py-[.1rem] px-[.4rem] font-normal';
  }

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      width: 65,
      sortable: false,
      align: 'center',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "prazoAvaliacao",
      filterable: false,
      headerName: "Prazo Avaliação",
      sortable: false,
      renderCell: (params) => (
        <div>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      field: "dataAvaliacao",
      filterable: false,
      headerName: "Data Avaliação",
      sortable: false,
      renderCell: (params) => (
        <div>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      field: "avaliacao",
      filterable: false,
      headerName: "Avaliação",
      flex: 1,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "avaliador",
      filterable: false,
      headerName: "Avaliador",
      flex: 1,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "totalPontos",
      filterable: false,
      headerName: "% Total Pontos",
      width: 135,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            {typeof params.value === 'string' &&
              <span className={computeTotalPontosClass(parseFloat(params.value))}>
                {parseFloat(params.value).toFixed(2)} %
              </span>
            }
            {typeof params.value === 'number' &&
              <span className={computeTotalPontosClass(params.value)}>
                {params.value.toFixed(2)} %
              </span>
            }
          </div>
        );
      },
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Exportar",
      sortable: false,
      valueGetter: (_, row) => { return row['idAvaliacaoHabilidade'] as number; },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={() => onExportar(value)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Exportar
          </Button>
        );
      },
    },
    {
      field: "acoes",
      filterable: false,
      headerName: "Ações",
      sortable: false,
      valueGetter: (_, row) => row['idAvaliacaoHabilidade'] as number,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onEditar(value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onDeletar(value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}